import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Switch from "react-switch";
import Loading from "../../components/Loading";
import { useTranslation } from "react-i18next";
import { LocationsModal } from "../Settings/VAT/LocationsModal";
import { onModifierArchive, onModifierEdit, onModifierLoad, onModifierNew,
         onModifierNewLoad,
         onModifierRemove,
         onModifiersEdit, onModifiersNew, onModifierUnarchive } from "../../store/Modifiers/actions";
import { DropdownMenu } from "./DropdownMenu";
import { useGetSettings } from '../../network';

export const Modifier = ({loading, modifier, itemId, slug, restaurants,
        checked_restaurants, all_future_locations, is_all_restaurants}) => {
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();

    const [isEdit, setIsEdit] = useState({isOpen: false, id: null});
    const [openModal, setOpenModal] = useState(false);
    const [checkChange, setCheckChange] = useState(true);
    const [locationChecked, setLocationChecked] = useState([]);
    const [selected, setSelected] = useState([]);
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [isCheckAllFutureLocations, setIsCheckAllFutureLocations] = useState(false);
    const [data, setData] = useState({
        id: null,
        name: "",
        is_required: false,
        can_items_repeat: false,
        max_checked: false,
        max_amount: null,
        items: [],
    });

    const [errors, setErrors] = useState({});

    const { data: settings = {} } = useGetSettings();

    useEffect(() => {
        if (itemId) {dispatch(onModifierLoad(itemId))}
        else {dispatch(onModifierNewLoad())}
    }, []);

    useEffect(() => {
        let items = modifier.data.modifier_items
                ? modifier.data.modifier_items.map((item) =>{
                    let total = item.price ? Number(item.price) : 0
                    if (item.tax_percent) {
                        const vat = ((item.price * item.tax_percent) / 100).toFixed(2);
                        total += Number(vat);
                        total = total.toFixed(2);
                    }
                    return(
                    {
                      id: item.id,
                      edit: false,
                      name: item.name ?? "",
                      price: total,
                      tax_percent: item.tax_percent ?? "",
                  })})
                : [];
            setData({
                id: modifier.data.id,
                name: modifier.data.name,
                is_required: modifier.data.is_required ?? false,
                can_items_repeat: modifier.data.can_items_repeat ?? false,
                max_checked: modifier.data.max_amount > 0 ?? false,
                max_amount: modifier.data.max_amount || 0,
                items: items,
            });
    }, [setData, modifier]);

    const restId = checked_restaurants?.map(item => item.id)
    const allRestaurants = restaurants?.map(rest=>(
        {name: rest.name, id: rest.id, checked: restId?.includes(rest.id)}))

    useEffect(() => {
        setLocationChecked(allRestaurants);
        setIsCheckAll(is_all_restaurants);
        setIsCheckAllFutureLocations(all_future_locations);
        setSelected(checked_restaurants || [])
    }, [checked_restaurants, is_all_restaurants, all_future_locations]);

    const addItem = () => {
        if(!itemId) return
        let item = { name: "", price: "", tax_percent: "", edit: true };
        setData({ ...data, items: [...data.items, item] });
        setIsEdit({isOpen: false, id: null})
    };

    const changeItem = (index, id) => {
        let newItems = [...data.items];
        if(newItems[index].name === "" || newItems[index].price === "") return
        newItems[index] = { ...newItems[index], edit: false };
        setData({ ...data, items: newItems });
        setIsEdit({isOpen: false, id: null});
        if(id){dispatch(onModifierEdit(itemId, newItems[index]))}
        else{dispatch(onModifierNew(itemId, newItems[index]))}
    }

    const onEditHandler = (id)=>{setIsEdit({isOpen: true, id})}

    const removeItem = (index) => {
        let newItems = [...data.items];
        if(newItems[index].id){dispatch(onModifierRemove(itemId, newItems[index].id))}
        newItems.splice(index, 1);
        setData({ ...data, items: newItems });
    };

    const changeItemName = (index, value) => {
        let newItems = [...data.items];
        newItems[index] = { ...newItems[index], name: value };
        setData({ ...data, items: newItems });
    };

    const changeItemPrice = (index, value) => {
        if(isNaN(value)) return
        let newItems = [...data.items];
        newItems[index] = { ...newItems[index], price: value };
        setData({ ...data, items: newItems });
    };

    const validateForm = () => {
        let valid = true;
        let errors = {};
        if (!data.name) {
            valid = false;
            errors["name"] = "Empty modifier name";
        }

        setErrors(errors);
        return valid;
    };

    const changeCategoryName = (e) => setData({ ...data, name: e.target.value });
    const handleRequiredChange = () => setData({ ...data, is_required: !data.is_required });
    const handleChosenChange = () => setData({ ...data, can_items_repeat: !data.can_items_repeat });
    const handleMaximumChange = () => {setData({ ...data, max_checked: !data.max_checked })};
    const changeMaximumAmount = (value) => setData({ ...data, max_amount: value });

    const onOpenModal = () => {
        setOpenModal((prev) => !prev);
        setCheckChange((prev) => !prev)
    };

    const onCloseModal = () => {
        setOpenModal((prev) => !prev);
        setCheckChange((prev) => !prev)
    };

    const onSaveLocations = () => {onCloseModal()};

    const onChangeLocations = (name) => {
        const newLoaction = locationChecked.map((item) =>
            item.name === name
                ? { ...item, checked: !item.checked }
                : { ...item }
        );

        setLocationChecked(newLoaction);
        const checkedArr = newLoaction.filter(({ checked }) => checked);

        if (checkedArr.length === locationChecked.length) {
            setIsCheckAll(true);
        } else {
            setIsCheckAll(false);
        }

        setSelected(checkedArr);
    };

    const handleSelectAll = () => {
        setIsCheckAll(!isCheckAll);
        const allLoaction = locationChecked.map((item) => ({
            ...item,
            checked: true,
        }));
        setLocationChecked(allLoaction);
        setSelected(allLoaction);

        if (isCheckAll) {
            const notLoaction = locationChecked.map((item) => ({
                ...item,
                checked: false,
            }));
        setLocationChecked(notLoaction);
        setSelected([]);
        }
    };

    const handleSelectAllFutureLocations = () => {setIsCheckAllFutureLocations(!isCheckAllFutureLocations)};

    const selectedIds = selected.map(item=>item.id)

    let buttonName1 = isCheckAll? t("All Locations"): selected.map(({ name }) => (<span className="mr-2" key={name}>{name}</span>));
    let buttonName2 = isCheckAllFutureLocations ? t("All Future Locations") : null;

    // const onSave = () => {
    //     if (!validateForm()) return false;
    //     if (itemId) { dispatch(onModifiersEdit(data, selectedIds, isCheckAllFutureLocations ? 1 : 0, isCheckAll ? 1 : 0))}
    //     else { dispatch(onModifiersNew(data, selectedIds, isCheckAllFutureLocations ? 1 : 0, isCheckAll ? 1 : 0))}
    // }

    const onSave = () => {
        if (!validateForm()) return false;
        if (itemId) { dispatch(onModifiersEdit(data, slug))}
        else { dispatch(onModifiersNew(data, slug))}
    };

    const onArchive = () => {if (itemId) {dispatch(onModifierArchive(itemId))}};
    const onUnArchive = () => {if (itemId) {dispatch(onModifierUnarchive(itemId))}};

    return (
        <Loading loading={loading}>
            <div className="rounded-lg shadow-md bg-white">
                <div className="grid grid-cols-2 gap-1 mb-44">
                    <div className="pt-5 px-5 pb-4">
                        <div className="col-span-3 sm:col-span-3 py-1 mb-1">
                            <label
                                htmlFor="name"
                                className="block text-sm font-bold text-black-800 mb-1"
                            >
                                {t("Category Name")}
                            </label>

                            <input
                                name="name"
                                value={data.name || ""}
                                placeholder={t("Name")}
                                onChange={(e)=>changeCategoryName(e)}
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                                type="text"
                            />
                            <div style={{ color: "red" }}>
                                {errors["name"]}
                            </div>
                        </div>

                        <table className="min-w-full mt-3">
                            <thead>
                                <tr className="border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50">
                                    <th
                                        scope="col"
                                        className="pl-3 py-2 text-left text-sm font-bold "
                                    >
                                        {t("Name")}
                                    </th>
                                    <th
                                        scope="col"
                                        className="pl-16 py-2 text-center text-sm font-bold"
                                    >
                                        {t("Price incl. VAT")}
                                    </th>
                                </tr>
                            </thead>
                        </table>

                        {!itemId
                            ?
                                (data.items.map(
                                        (item, index) => (
                                            <div className="max-w-full mx-auto pl-2" key={`new${index}`}>
                                                <div className="border-b-2 border-gray-200 py-1.5">
                                                    <div className="px-3 bg-white relative">
                                                        <div className="flex items-center justify-between ">
                                                            <div className='flex justify-between w-11/12'>
                                                                {item.edit
                                                                    ? (
                                                                        <div className="flex items-center justify-around">
                                                                            <input
                                                                                type="text"
                                                                                value={item.name || ""}
                                                                                onChange={(e) => changeItemName(index, e.target.value)}
                                                                                className="input py-1 mr-16 border-gray-200 focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                value={item.price || ""}
                                                                                onChange={(e) => changeItemPrice(index, e.target.value)}
                                                                                className="input py-1 border-gray-200 focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-2/3 shadow-sm sm:text-sm rounded-md"
                                                                            />
                                                                            <button
                                                                                type="button"
                                                                                onClick={()=>changeItem(index, null)}
                                                                                className="inline-flex justify-center py-1.5 px-4 ml-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 focus:outline-none"
                                                                            >
                                                                                {t("Save")}
                                                                            </button>
                                                                        </div>
                                                                    )
                                                                    :
                                                                    (
                                                                        isEdit.id === index && isEdit.isOpen
                                                                            ? (
                                                                                <div className="flex items-center justify-around">
                                                                                    <input
                                                                                        type="text"
                                                                                        value={item.name || ""}
                                                                                        onChange={(e) => changeItemName(index, e.target.value)}
                                                                                        className="input py-1 mr-16 border-gray-200 focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                                                                                    />
                                                                                    <input
                                                                                        type="text"
                                                                                        value={item.price || ""}
                                                                                        onChange={(e) => changeItemPrice(index, e.target.value)}
                                                                                        className="input py-1 border-gray-200 focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-2/3 shadow-sm sm:text-sm rounded-md"
                                                                                    />
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={()=>changeItem(index, item.id)}
                                                                                        className="inline-flex justify-center py-1.5 px-4 ml-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 focus:outline-none"
                                                                                    >
                                                                                        {t("Save")}
                                                                                    </button>
                                                                                </div>)
                                                                            : (
                                                                                <div className="flex items-center justify-between w-4/5">
                                                                                    <span className="text-sm font-medium">
                                                                                        {item.name}
                                                                                    </span>
                                                                                    <span className="text-sm font-medium">
                                                                                        {settings.currency?.title} {item.price}
                                                                                    </span>
                                                                                </div>
                                                                            )
                                                                    )
                                                                }
                                                            </div>
                                                            <div>
                                                                <DropdownMenu
                                                                    setIsEdit={setIsEdit}
                                                                    removeItem={removeItem}
                                                                    onEditHandler={onEditHandler}
                                                                    id={index}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    ))
                            :
                                ( data.items.map((item,index) => (
                                    <div className="max-w-full mx-auto pl-2" key={`edit${index}`}>
                                        <div className="border-b-2 border-gray-200 py-1.5">
                                            <div className="px-3 bg-white relative">
                                                <div className="flex items-center justify-between ">
                                                    <div className='flex justify-between w-11/12'>
                                                    {!item.edit
                                                        ? ( isEdit.id === index && isEdit.isOpen
                                                            ? (
                                                                <div className="flex items-center justify-around">
                                                                    <input
                                                                        type="text"
                                                                        value={item.name || ""}
                                                                        onChange={(e) => changeItemName(index, e.target.value)}
                                                                        className="input py-1 mr-16 border-gray-200 focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                                                                    />
                                                                    <input
                                                                        type="text"
                                                                        value={item.price || ""}
                                                                        onChange={(e) => changeItemPrice(index, e.target.value)}
                                                                        className="input py-1 border-gray-200 focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-2/3 shadow-sm sm:text-sm rounded-md"
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        onClick={()=>changeItem(index, item.id)}
                                                                        className="inline-flex justify-center py-1.5 px-4 ml-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 focus:outline-none"
                                                                    >
                                                                        {t("Save")}
                                                                    </button>
                                                                </div>)
                                                                : (
                                                                    <div className="flex items-center justify-between w-4/5">
                                                                        <span className="text-sm font-medium">
                                                                            {item.name}
                                                                        </span>
                                                                        <span className="text-sm font-medium">
                                                                            {settings.currency?.title} {item.price}
                                                                        </span>
                                                                    </div>
                                                                    )
                                                            )
                                                        :
                                                            (
                                                            <div className="flex items-center justify-around">
                                                                <input
                                                                    type="text"
                                                                    value={item.name || ""}
                                                                    onChange={(e) => changeItemName(index, e.target.value)}
                                                                    className="input py-1 mr-16 border-gray-200 focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                                                                />
                                                                 <input
                                                                    type="text"
                                                                    value={item.price || ""}
                                                                    onChange={(e) => changeItemPrice(index, e.target.value)}
                                                                    className="input py-1 border-gray-200 focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-2/3 shadow-sm sm:text-sm rounded-md"
                                                                />
                                                                <button
                                                                    type="button"
                                                                    onClick={()=>changeItem(index, null)}
                                                                    className="inline-flex justify-center py-1.5 px-4 ml-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 focus:outline-none"
                                                                >
                                                                    {t("Save")}
                                                                </button>
                                                            </div>
                                                        )}

                                                    </div>
                                                    <DropdownMenu
                                                        setIsEdit={setIsEdit}
                                                        removeItem={removeItem}
                                                        onEditHandler={onEditHandler}
                                                        id={index}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                )
                            )}

                        <button
                            type="button"
                            onClick={addItem}
                            className={`inline-flex justify-center py-1.5 px-4 ml-1 mt-8 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white ${!itemId? "bg-gray-600" : "bg-gray-900 "} hover:bg-gray-600 focus:outline-none`}
                        >
                            {t("Add Item")}
                        </button>

                        <div>
                            <p className="text-sm font-bold mt-6 mb-2.5">{t("Modifier Rules")}</p>

                            <div className="col-span-3 flex items-center ml-2">
                                <Switch
                                    id="handle_required"
                                    onChange={handleRequiredChange}
                                    checked={data.is_required}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    onColor="#7f56d9"
                                    height={20}
                                    width={44}
                                />
                                <label
                                    htmlFor="handle_required"
                                    className="block text-sm font-medium text-gray-700 ml-2 cursor-pointer">
                                    {t("Are these options required?")}
                                </label>
                            </div>

                            <div className="col-span-3 flex items-center mt-4 mb-2 ml-2">
                                <Switch
                                    id="handle_max"
                                    onChange={handleMaximumChange}
                                    checked={data.max_checked}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    onColor="#7f56d9"
                                    height={20}
                                    width={44}
                                />
                                <label
                                    htmlFor="handle_max"
                                    className="block text-sm font-medium text-gray-700 ml-2 cursor-pointer">
                                    {t("Maximum number of items customer can select")}
                                </label>
                            </div>
                            {data.max_checked ? (
                                <div className="flex items-center px-8 ml-6">
                                    <input
                                        type="text"
                                        value={data.max_amount}
                                        onChange={(e) => changeMaximumAmount(e.target.value)}
                                        className="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block"
                                    />
                                </div>
                            ) : null}

                            <div className="col-span-3 flex items-center mt-4 ml-2">
                                <Switch
                                    id="can_repeat"
                                    onChange={handleChosenChange}
                                    checked={data.can_items_repeat}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    onColor="#7f56d9"
                                    height={20}
                                    width={44}
                                />
                                <label
                                    htmlFor="can_repeat"
                                    className="block text-sm font-medium text-gray-700 ml-2 cursor-pointer">
                                    {t("Can these options be chosen more than once?")}
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="pt-5 pr-16 pb-4 pl-5">
                        <div className="col-span-3 sm:col-span-3 py-1 mb-1 block w-2/3 bg-white rounded-md focus:outline-none sm:text-sm">
                            <label
                                htmlFor="select_stores"
                                className="block text-sm font-bold text-black-800"
                            >
                                {t("Add to Stores")}
                            </label>
                            <button
                                onClick={onOpenModal}
                                type="button"
                                name="select_stores"
                                className="text-left text-sm mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block truncate w-full shadow-sm sm:text-sm rounded-md px-3 py-2"
                            >
                                {checkChange ? (
                                    <>
                                        <span className="mr-1.5 text-black">
                                            {selected && buttonName1}
                                        </span>
                                        <span className="text-black">
                                            {isCheckAllFutureLocations &&
                                                buttonName2}
                                        </span>
                                        {!selected.length && !isCheckAllFutureLocations && !isCheckAll &&(
                                                <span className="text-gray-400 italic text-sm">
                                                    {t("Add to Stores")}
                                                </span>
                                            )}
                                    </>
                                    ) : ""}
                            </button>

                            <LocationsModal
                                visible={openModal}
                                onClose={onCloseModal}
                                onSave={onSaveLocations}
                                onChangeLocations={onChangeLocations}
                                locations={locationChecked}
                                isCheckAll={isCheckAll}
                                isCheckAllFutureLocations={isCheckAllFutureLocations}
                                handleSelectAll={handleSelectAll}
                                handleSelectAllFutureLocations={handleSelectAllFutureLocations}
                            />
                        </div>
                    </div>
                </div>

                <div
                    className="px-4 py-5 text-right sm:px-6 flex items-center w-full"
                    style={{
                        justifyContent: itemId
                            ? "space-between"
                            : "flex-end",
                    }}
                >
                    {itemId && !modifier.data.archived_at ? (
                        <button
                            className="inline-flex justify-center py-1.5 px-3 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-red-600 hover:bg-red-400"
                            onClick={onArchive}
                            type="button"
                        >
                            {t("Archive_action")}
                        </button>
                    ) : null}

                    {itemId && modifier.data.archived_at ? (
                        <button
                            className="inline-flex justify-center py-1.5 px-3 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-purple-500 hover:bg-purple-300"
                            onClick={onUnArchive}
                            type="button"
                        >
                            {t("Unarchive_action")}
                        </button>
                    ) : null}

                    <div>
                        <button
                            type="button"
                            className="inline-flex justify-center py-1.5 px-5 border border-transparent shadow-sm text-sm font-bold rounded-lg bg-gray-100 hover:bg-gray-200 focus:outline-none"
                            onClick={() => history.goBack()}
                        >
                            {t("Cancel")}
                        </button>
                        <button
                            type="button"
                            onClick={onSave}
                            className="inline-flex justify-center py-1.5 px-6 ml-2 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 focus:outline-none"
                        >
                            {t("Save")}
                        </button>
                    </div>
                </div>
            </div>
        </Loading>
    );
};
